"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _style = _interopRequireDefault(require("./style.css"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

var cx = _bind["default"].bind(_style["default"]);

var Groups = function Groups(_ref) {
  var options = _ref.options,
      handleChange = _ref.handleChange,
      selectedCountMap = _ref.selectedCountMap;
  return /*#__PURE__*/_jsx("ul", {
    className: cx('xsui-group-select__groups')
  }, void 0, options.map(function (option, index) {
    var selectedCount = selectedCountMap[option.value] || 0;
    var groupItemsCount = option.children.length;
    return /*#__PURE__*/_jsx("li", {
      className: cx('xsui-group-select__groups__option', option.active && 'xsui-group-select__groups__option--active'),
      onClick: handleChange.bind(_this, option.value)
    }, "group-".concat(index), /*#__PURE__*/_jsx("span", {
      className: "xsui-group-select__option-label"
    }, void 0, option.label), /*#__PURE__*/_jsx("span", {
      className: "xsui-group-select__option-count"
    }, void 0, groupItemsCount === selectedCount ? groupItemsCount : "".concat(selectedCount, "/").concat(groupItemsCount)));
  }));
};

var _default = Groups;
exports["default"] = _default;